import './css/main.css';

import './css/fullpage.css';

import barba from '@barba/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

import 'vidstack/player';
import 'vidstack/player/layouts/default';
import 'vidstack/player/ui';
import 'vidstack/player/styles/default/theme.css';
import 'vidstack/player/styles/default/layouts/video.css';

barba.init({
  debug: true,
  timeout: 7000,
  transitions: [
    {
      name: 'opacity-transition',
      leave(data) {
        return gsap.to(data.current.container, {
          opacity: 0
        });
      },
      // * MA added this beforeEntry bit
      beforeEnter: function beforeEnter(data) {},
      enter(data) {},
      after(data) {
        return gsap.from(data.next.container, {
          opacity: 0
        });
      },
      afterOnce(data) {},
      once(data) {}
    }
  ]
});

import('./js/components/menuScroll.js').then(module => {
  const scrollIt = module.default;
  scrollIt();
});

function fpCheck(data) {
  let fullP = document.getElementById('fullpage');
  if (fullP != undefined && fullP != null) {
    import('./js/components/fullpage.js').then(module => {
      // const gridIt = module.default;
      // gridIt(data);
    });
  }
}

function scrollToTop() {
  // window.scrollTo({top: 0, behavior: 'smooth'});
  window.scrollTo({ top: 0 });
}

// ? this function adds the masGrid class on bigger screens only
function mobileNoGrid(data) {
  const projectGrid = document.querySelector('[data-masgrid]');

  const updateMasGridClass = () => {
    if (projectGrid) { // Check if projectGrid exists
      if (window.innerWidth >= 768) { // Tailwind's `md` breakpoint
        projectGrid.classList.add('masGrid');
      } else {
        projectGrid.classList.remove('masGrid');
      }
    }
  };

  // Initial check
  updateMasGridClass();

  // Listen for resize events
  window.addEventListener('resize', updateMasGridClass);
}

// Ensure the DOM is fully loaded before running the function
document.addEventListener('DOMContentLoaded', () => {
  mobileNoGrid();
})

function gridCheck(data) {
  let grids = document.getElementsByClassName('masGrid');
  if (grids.length > 0) {
    import('./js/components/grid.js').then(module => {
      const gridIt = module.default;
      gridIt(data);
    });
  }
}

function projectsCheck(data) {
  import('./js/components/projectsMenu.js').then(module => {
    const projIt = module.default;
    projIt(data);
  });
}

function studioCheck(data) {
  import('./js/components/studioMenu.js').then(module => {
    const projIt = module.default;
    projIt(data);
  });
}

function galleryCheck(data) {
  let gallery = document.getElementsByClassName('gallery');
  if (gallery.length > 0) {
    import('./js/components/gallery.js').then(module => {
      const galleryIt = module.default;
      galleryIt(data);
    });
  }
}

function mapCheck(data) {
  let map = document.getElementsByClassName('contactMap');
  if (map.length > 0) {
    import('./js/components/map.js').then(module => {
      const mapIt = module.default;
      mapIt(data);
    });
  }
}

function projectImageHover() {
  let projectImageDiv = document.getElementsByClassName('projectImage');
  let projectText = document.getElementsByClassName('projImageHover');
  if (projectImageDiv.length > 0 && projectText.length > 0) {
    import('./js/components/projectHover.js').then(module => {
      const projHovIt = module.default;
      projHovIt();
    });
  }
}

function projIndexList() {
  let listItems = document.getElementsByClassName('projectIndexListItems');
  if (listItems.length > 0) {
    import('./js/components/projIndexList.js').then(module => {
      const projListIt = module.default;
      projListIt();
    });
  }
}

function partnerList() {
  let listItemsPartner = document.getElementsByClassName('partnerListData');
  if (listItemsPartner.length > 0) {
    import('./js/components/partnerList.js').then(module => {
      const partnerListIt = module.default;
      partnerListIt();
    });
  }
}

function splash(data) {
  import('./js/components/splash.js').then(module => {
    const splashIt = module.default;
    splashIt(data);
  });
}

let searchIcon = document.getElementById('searchIcon');
searchIcon.addEventListener('click', () => {
  toggleSearch('open');
});

function toggleSearch(goState) {
  import('./js/components/searchToggle.js').then(module => {
    const searchIt = module.default;
    searchIt(goState);
  });
}

function hamburgerToggle(preset) {
  import("./js/components/hamburgerToggle.js").then(module => {
      const toggle = module.default;
      toggle(preset);
  });
}

function projfilterToggle(preset) {
  import("./js/components/projFilterMenu.js").then(module => {
      const toggleProj = module.default;
      toggleProj(preset);
  });
}

function projCheck() {
  let projFilters = document.getElementsByClassName('projFilters ');
  if (projFilters.length > 0) {
    let projOpen = document.getElementById("openProjFilters");
      projOpen.addEventListener("click", function() {projfilterToggle()});

    let projCloser = document.getElementById("projFilterCloser");
    projCloser.addEventListener("click", function() {projfilterToggle('c')});
  }
}




let hamburgerOuter = document.getElementById("hamburgerOuter");
hamburgerOuter.addEventListener("click", function() {hamburgerToggle()});


history.scrollRestoration = "manual";
let scrollPosY = [0];


barba.hooks.once(data => {
  splash(data);
  projectsCheck(data);
  mobileNoGrid(data);
  studioCheck(data);
  galleryCheck(data);
  // reloadSprig();
  projectImageHover();
  projIndexList();
  projCheck();
  partnerList();
  // subMenuToggle('open');
  
});

barba.hooks.afterOnce(data => {
  mapCheck(data);
  // mobileNoGrid(data);
  gridCheck(data);
  setTimeout(() => {
    gridCheck(data);
  }, 500);
});

barba.hooks.before(data => {
  if(data.trigger !== "back") {
    scrollPosY.push(barba.history.current.scroll.y);
    console.log(barba.history.current.scroll.y)
    console.log(scrollPosY)
  }
  hamburgerToggle('c');
  projfilterToggle('c');
  fpCheck(data);
  
});

barba.hooks.enter(data => {
  
  projectsCheck(data);
  studioCheck(data);
  
});

barba.hooks.beforeEnter(data => {
  // scrollToTop();
  
});

barba.hooks.after(data => {
  
  toggleSearch('close');
  mapCheck(data);
  mobileNoGrid(data);
  gridCheck(data);
  fpCheck(data);
  galleryCheck(data);
  // reloadSprig();
  projectImageHover();
  projIndexList();
  projCheck();
  partnerList();
  // subMenuToggle('open');
  if(data.trigger !== "back") {
    window.scrollTo(0,0);
  } else {
    setTimeout(() => {window.scrollTo(0, scrollPosY.pop())}, 100);
    console.log(scrollPosY)
  }
  
});
